module.exports = __webpack_public_path__ + "img/card_background.b52451de.png";